import { w as r } from "./isValidPhoneNumber-e7deec18.mjs";
import { a as t } from "./parsePhoneNumberWithError-dbe50dd0.mjs";
function o() {
  return r(t, arguments);
}
export {
  o as p
};
//# sourceMappingURL=parsePhoneNumberWithError-36fb3222.mjs.map
